export function resolveUrl(resolvePath: string, target: string) {
    return new URL(resolvePath, target).href
}

const TRAILING_SLASH_RE = /\/$/
export function removeTrailingSlash(path: string) {
    return path.replace(TRAILING_SLASH_RE, '')
}

const LEADING_SLASH_RE = /^\//
export function removeLeadingSlash(path: string) {
    return path.replace(LEADING_SLASH_RE, '')
}

const LEADING_HASH_RE = /^#\/?/
export function removeLeadingHash(hash: string) {
    return hash.replace(LEADING_HASH_RE, '')
}

export function combineUrl(...args: string[]) {
    const [base, ...paths] = args
    return [removeTrailingSlash(base), ...paths.map(removeLeadingSlash)].filter(Boolean).join('/')
}

export function combineHash(url: string, hash: string) {
    return combineUrl(url, '#', removeLeadingHash(removeLeadingSlash(hash)))
}
